import Http from '../http'

export const index = (data) => Http.get(`/reports?types=${data.types}&from=${data.from}&to=${data.to}`, { headers: { Authorization: localStorage.token } })
export const analyticCategories = (data) => Http.get('/analytics/categories', { headers: { Authorization: localStorage.token } })
export const updateReportMonth = (data) => Http.patch(`/analytics/categories/${data.id}`, data, { headers: { Authorization: localStorage.token } })
